import { compareAsc, isPast, isToday, parseISO } from "date-fns";
import { DatoSupportModelApiKey } from "../../types/DatoModalApiKey";
const phoneModelKeys = [
    DatoSupportModelApiKey.SHARED_SUPPORT_OPENING_TIME_OPEN24H,
    DatoSupportModelApiKey.SHARED_SUPPORT_OPENING_TIME,
];
const parseOpeningTimeEntry = (entry) => ({
    opensAt: ("opensAt" in entry && entry.opensAt) || undefined,
    closesAt: ("closesAt" in entry && entry.closesAt) || undefined,
    isOpenAllDay: entry._modelApiKey ===
        DatoSupportModelApiKey.SHARED_SUPPORT_OPENING_TIME_OPEN24H,
    isClosedAllDay: ("opensAt" in entry && !entry.opensAt) ||
        ("closesAt" in entry && !entry.closesAt),
});
const parseSpecialOpeningTimeEntry = (entry) => ({
    fromDate: entry.dateFrom,
    toDate: ("dateThrough" in entry && entry.dateThrough) || entry.dateFrom,
    opensAt: ("opensAt" in entry && entry.opensAt) || undefined,
    closesAt: ("closesAt" in entry && entry.closesAt) || undefined,
    isOpenAllDay: entry._modelApiKey ===
        DatoSupportModelApiKey.SHARED_SUPPORT_SPECIAL_OPENING_TIME_OPEN24H,
    isClosedAllDay: ("opensAt" in entry && !entry.opensAt) ||
        ("closesAt" in entry && !entry.closesAt),
});
const parse = ({ openingHours, }) => {
    const phoneEntries = Object.values(openingHours).filter((entry) => {
        var _a;
        return typeof entry !== "string" &&
            entry[0] &&
            phoneModelKeys.includes((_a = entry[0]) === null || _a === void 0 ? void 0 : _a._modelApiKey);
    });
    return {
        phone: phoneEntries.map((entry) => parseOpeningTimeEntry(entry[0])),
        special: openingHours.specialOpeningTimes
            .map((entry) => parseSpecialOpeningTimeEntry(entry))
            .filter(({ toDate }) => !isPast(parseISO(toDate)) || isToday(parseISO(toDate)))
            .sort(({ fromDate }, { fromDate: previousFromDate }) => compareAsc(parseISO(fromDate), parseISO(previousFromDate))),
        timezone: openingHours.timezone,
    };
};
export default parse;
